import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { ConditionalLink } from '@plone/volto/components';
import TagsView from './TagsView';
import PreviewItemDates from './PreviewItemDates';
import {
  ItemDescription,
  PriceRangeIndications,
  ListingImage,
} from '@package/components';

/** Può essere usato per mostrare sia oggetti di tipo 'Evento' sia oggetti di tipo 'Esperienza' (nella ricerca delle esperienze, le esperienze vengono mostrate con questo componente) */
const EventItem = ({
  item,
  isEditMode,
  infoInTitle = false,
  showDescription = false,
}) => {
  const is_experience = item['@type'] === 'Esperienza' || item.is_experience;

  const infos = <PreviewItemDates item={item} />;

  return (
    <div className="item event-item">
      <div className="item-content">
        <ConditionalLink
          to={flattenToAppURL(item['@id'])}
          condition={!isEditMode}
          aria-hidden="true"
          role="presentation"
          tabIndex="-1"
        >
          {item.thematic_area?.title && (
            <TagsView subjects={[item.thematic_area.title]} />
          )}
          {!infoInTitle && infos}

          <ListingImage item={item} />
          <PriceRangeIndications item={item} />
        </ConditionalLink>
      </div>

      <div className="item-title">
        <ConditionalLink
          to={flattenToAppURL(item['@id'])}
          condition={!isEditMode}
        >
          <h3>{item.title ? item.title : item.id}</h3>
        </ConditionalLink>
        {infoInTitle && infos}
      </div>
      {is_experience && item.municipality?.title && (
        <div className="municipality">{item.municipality?.title}</div>
      )}
      {item.location_text && (
        <div className="municipality">{item.location_text}</div>
      )}
      {showDescription && <ItemDescription item={item} />}
    </div>
  );
};

EventItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default EventItem;
